// @flow

type TimePoints = {
  beginJs: number,
  beforeImport: number,
  pageLoaded: number,
  appInitialized: number,
  bookingLoading: number,
  bookingLoadingSuccess: number,
}

const timePoints: TimePoints = {
  beginJs: typeof window !== "undefined" && window.SP_TRACK_PERF ? window.SP_TRACK_PERF.beginJs : 0,
  beforeImport: -1,
  pageLoaded: -1,
  appInitialized: -1,
  bookingLoading: -1,
  bookingLoadingSuccess: -1,
}

const getCurrentTime = (): number => Date.now()

// -- time events
export function onBeforeImport(): number {
  return (timePoints.beforeImport = getCurrentTime())
}

export function onPageLoaded(): number {
  return (timePoints.pageLoaded = getCurrentTime())
}

export function onAppInitialized(): number {
  return (timePoints.appInitialized = getCurrentTime())
}

export function onBookingLoading(): number {
  return (timePoints.bookingLoading = getCurrentTime())
}

export function onBookingLoadingSuccess(): number {
  return (timePoints.bookingLoadingSuccess = getCurrentTime())
}

// -- duration getters
export const getBeginToBeforeImportDuration = (): number =>
  timePoints.beforeImport - timePoints.beginJs
export const getBeginToPageLoadedDuration = (): number => timePoints.pageLoaded - timePoints.beginJs
export const getBeginToAppInitializedDuration = (): number =>
  timePoints.appInitialized - timePoints.beginJs
export const getBeginToBookingLoadingDuration = (): number =>
  timePoints.bookingLoading - timePoints.beginJs
export const getBeginToBookingLoadingSuccessDuration = (): number =>
  timePoints.bookingLoadingSuccess - timePoints.beginJs
export const getBookingLoadingDuration = (): number =>
  timePoints.bookingLoadingSuccess - timePoints.bookingLoading
export const getTimeFromPageLoad = (): number => getCurrentTime() - timePoints.pageLoaded
export const getTimeFromBookingLoadingSuccess = (): number =>
  getCurrentTime() - timePoints.bookingLoadingSuccess
export const getTimeFromAppInitialized = (): number => getCurrentTime() - timePoints.appInitialized
